import * as React from 'react';

import { IForm } from "../IForm";
import { AssignPersonStoreState } from "./AssignPersonStore";
import { AssignPersonActions } from "./AssignPersonActions";
import { Select } from "../../../../components/Select";
import { intToString, stringToInt } from "../../../../converters/converters";
import { assertNumber } from "../../../utils/assert";
import { Polyglot } from '../../../../polyglot';

interface FormProps {
    polyglot: Polyglot;
}
type Props = AssignPersonStoreState & Partial<AssignPersonActions> & FormProps;
export class AssignPerson extends React.Component<Props> implements IForm
{
    render()
    {
        const {
            draft,
            durations, setDuration
        } = this.props;
        const { Duration } = draft;

        return (
            <div className="form-horizontal" style={{width: 510, padding: 15}}>
                {this.props.polyglot.t('dashboard.excess_assignment.message')}
                <div className='form-group'>                    
                    <div className='col-sm-4'>
                        <Select className='form-control'
                            placeholder='---'
                            items={durations}
                            defaultValue={intToString(Duration)}
                            valueFn={n => intToString(n)}
                            titleFn={this.getTitle}
                            onChange={s => {
                                const duration = stringToInt(s.getValue());
                                assertNumber(duration, 'duration has to be a number');
                                setDuration(duration);
                            }}/>
                    </div>
                </div>
            </div>
        );
    }

    private getTitle = (duration: number) => {
        const minUnit = this.props.polyglot.t('units.min');
        if(duration < 60)
            return `${duration} ${minUnit}`;
        
        const hours = Math.floor(duration / 60);
        const mins = duration % 60;

        const hourUnit = this.props.polyglot.t('units.hours', { smart_count: hours });
        if(mins === 0)
            return `${hours} ${hourUnit}`;
        return `${hours} ${hourUnit} ${mins} min`;
    }

    getValue = () => ({ ...this.props.draft });
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Home/AssignPerson.tsx